import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'
import { PaktMark } from '../components/pakt'

export default function SignComplete() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const verificationCode = searchParams.get('code') || ''
  const downloadUrl = searchParams.get('download') || ''

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 max-w-md w-full text-center">
        {/* Success checkmark */}
        <div className="mx-auto w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mb-6">
          <svg
            className="w-10 h-10 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2.5}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          {t('signComplete.title', 'Document signed successfully!')}
        </h1>
        <p className="text-gray-600 mb-6">
          {t(
            'signComplete.desc',
            'Your signature has been recorded. All parties will be notified when the document is fully signed.',
          )}
        </p>

        {verificationCode && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-xs font-medium text-gray-500 mb-1">
              {t('signComplete.verificationCode', 'Verification Code')}
            </p>
            <p className="font-mono text-lg font-bold text-gray-900">{verificationCode}</p>
            <p className="text-xs text-gray-400 mt-1">
              {t('signComplete.verificationHint', 'Use this code to verify the document authenticity')}
            </p>
          </div>
        )}

        <div className="space-y-3">
          {verificationCode && (
            <Link
              to={`/verify/${verificationCode}`}
              className="block w-full py-2.5 border border-indigo-600 text-indigo-600 font-medium rounded-lg hover:bg-indigo-50 transition"
            >
              {t('signComplete.verify', 'Verify Document')}
            </Link>
          )}

          {downloadUrl && (
            <a
              href={downloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full py-2.5 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition"
            >
              {t('signComplete.download', 'Download Signed Document')}
            </a>
          )}

          <Link
            to="/"
            className="block w-full py-2.5 text-gray-600 hover:text-gray-900 font-medium transition text-sm"
          >
            {t('signComplete.home', 'Go to Homepage')}
          </Link>
        </div>

        {/* Powered by PAKT CTA */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm font-semibold text-gray-900 mb-1">
            {t('signComplete.ctaHeading', 'Need to send contracts yourself?')}
          </p>
          <p className="text-xs text-gray-500 mb-4">
            {t(
              'signComplete.ctaDesc',
              'PAKT lets you collect legally binding e-signatures with bank-verified identity — in minutes, not days.',
            )}
          </p>
          <Link
            to="/register"
            className="block w-full py-2.5 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition text-sm"
          >
            {t('signComplete.ctaButton', 'Create my free account')}
          </Link>
          <p className="text-[10px] text-gray-400 mt-2">
            {t('signComplete.poweredBy', 'Powered by PAKT')}
          </p>
        </div>
      </div>
    </div>
  )
}
